/**
 * @file PaddleHub 上传模型浮窗Hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import { useCallback, useEffect, useRef, useState } from 'react';
import { Form, message } from 'antd';
import { fetchGetMenuList, fetchUploadModelSubmit } from '../../../../api/pages/paddleHubApi';
import { useUserLoginState } from '../../../../components/header/headerHooks';

// 预请求
let preRequest: any = {
    fetchGetMenuList: fetchGetMenuList()
};

const useUploadModelModalHooks = () => {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState<boolean>(false);
    const onOk = useCallback(() => setVisible(false), []);
    const onCancel = useCallback(() => setVisible(false), []);

    const onOkSubmit = useCallback(async (values: any) => {
        const fileResponse = values.modelFileList.slice(-1)[0];
        const fileKey = fileResponse?.response?.body?.key;

        const res = await fetchUploadModelSubmit({
            modelCategory: values.modelCategory,
            modelName: values.modelName,
            modelAbs: values.modelAbs,
            userEmail: values.userEmail,
            fileKey
        }).catch(() => {
            message.error('提交失败，请稍候再试');
        });
        if (res && res.body) {
            message.success('提交模型5-7个工作日内，我们会将审核意见发到您的邮箱');
            setVisible(false);
        }
        else {
            message.error('提交失败，请稍候再试');
        }
    }, []);

    const { checkState } = useUserLoginState();
    const checkStateRef = useRef(checkState);
    checkStateRef.current = checkState;

    const setVisibleShow = useCallback(() => {
        setVisible(true);
    }, []);


    const [modelCategoryList, setModelCategoryList] = useState<string[]>([
        '文本',
        '图像',
        '视频',
        '其他'
    ]);
    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetMenuList || fetchGetMenuList();
            delete preRequest.fetchGetMenuList;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const data: any[] = res.body.result?.data || [];
                const list = data.map(item => item?.name?.chn ?? '');
                setModelCategoryList(list);
            }
        })();
    }, []);

    return {
        form,
        modelCategoryList,
        visible,
        setVisibleShow,
        onOk,
        onOkSubmit,
        onCancel
    };
};

export default useUploadModelModalHooks;
